var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { useIndicatorGroups } from "./use-indicator-groups";
import { useIndicators } from "./use-indicators";
import { compact, keyBy } from "lodash";
var defaultOptions = {
  mergeIndicatorResults: true
};
export var useEntityView = function (entity, viewHash, options) {
  var opts = __assign(__assign({}, defaultOptions), options);
  var mergeIndicatorResults = opts.mergeIndicatorResults;
  var groups = useIndicatorGroups();
  var indicators = useIndicators();
  // return useMemo(() => {
  var indicatorsById = keyBy(indicators, 'id');
  // find the view
  var view = entity.entityViews.find(function (view) {
    return view.hash === viewHash;
  });
  if (view) {
    var slices = view.slices.map(function (slice) {
      var _a, _b, _c;
      var resolvedSlice = __assign({}, slice);
      if (mergeIndicatorResults && ((_a = entity.indicatorResults) === null || _a === void 0 ? void 0 : _a.length)) {
        if ((_b = slice.indicators) === null || _b === void 0 ? void 0 : _b.length) {
          resolvedSlice.indicators = resolvedSlice.indicators.map(function (indicator) {
            // for each result, find the 
            var entityIndicator = indicatorsById[indicator.id] || {};
            return __assign(__assign(__assign({}, indicator), entityIndicator), {
              result: entity.indicatorResults.find(function (result) {
                var _a;
                return ((_a = result.indicator) === null || _a === void 0 ? void 0 : _a.id) === indicator.id;
              }),
              supportingIndicators: compact((indicator.supportingIndicators || []).map(function (supportingIndicator) {
                var entitySupportingIndicator = indicatorsById[supportingIndicator.id] || {};
                return __assign(__assign(__assign({}, supportingIndicator), entitySupportingIndicator), {
                  result: entity.indicatorResults.find(function (result) {
                    var _a;
                    return ((_a = result.indicator) === null || _a === void 0 ? void 0 : _a.id) === supportingIndicator.id;
                  })
                });
              }))
            });
          });
        }
        if ((_c = slice.indicatorGroups) === null || _c === void 0 ? void 0 : _c.length) {
          resolvedSlice.indicatorGroups = slice.indicatorGroups.map(function (indicatorGroup) {
            var group = groups.find(function (group) {
              return group.id === indicatorGroup.id;
            }) || {};
            return __assign(__assign(__assign({}, indicatorGroup), group), {
              indicators: group.indicators.map(function (indicator) {
                var entityIndicator = indicatorsById[indicator.id] || {};
                return __assign(__assign(__assign({}, indicator), entityIndicator), {
                  result: entity.indicatorResults.find(function (result) {
                    var _a;
                    return ((_a = result.indicator) === null || _a === void 0 ? void 0 : _a.id) === indicator.id;
                  }),
                  supportingIndicators: compact((indicator.supportingIndicators || []).map(function (supportingIndicator) {
                    var entitySupportingIndicator = indicatorsById[supportingIndicator.id] || {};
                    return __assign(__assign(__assign({}, supportingIndicator), entitySupportingIndicator), {
                      result: entity.indicatorResults.find(function (result) {
                        var _a;
                        return ((_a = result.indicator) === null || _a === void 0 ? void 0 : _a.id) === supportingIndicator.id;
                      })
                    });
                  }))
                });
              })
            });
          });
        }
      }
      return resolvedSlice;
    });
    return __assign(__assign({}, view), {
      slices: slices
    });
  }
  return null;
  // }, [entity.id, entity.updated, mergeIndicatorResults, viewHash, groups.map((group) => group.id).join(','), indicators.map((indicator) => indicator.id).join(',')]);
};